/* global moment */
/* eslint-env browser, jquery */
(function() {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
    );

  if ('serviceWorker' in navigator &&
      (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
      .then(function(registration) {
        // updatefound is fired if service-worker.js changes.
        registration.onupdatefound = function() {
          // updatefound is also fired the very first time the SW is installed,
          // and there's no need to prompt for a reload at that point.
          // So check here to see if the page is already controlled,
          // i.e. whether there's an existing service worker.
          if (navigator.serviceWorker.controller) {
            // The updatefound event implies that registration.installing is set:
            // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
            var installingWorker = registration.installing;

            installingWorker.onstatechange = function() {
              switch (installingWorker.state) {
                case 'installed':
                  // At this point, the old content will have been purged and the
                  // fresh content will have been added to the cache.
                  // It's the perfect time to display a "New content is
                  // available; please refresh." message in the page's interface.
                  break;

                case 'redundant':
                  throw new Error('The installing ' +
                                  'service worker became redundant.');

                default:
                  // Ignore
              }
            };
          }
        };
      }).catch(function(e) {
        console.error('Error during service worker registration:', e);
      });
  }

  // Your custom JavaScript goes here
  $(document).ready(function() {
    // Assuming you've got the appropriate language files,
    // clndr will respect whatever moment's language is set to.
    moment.locale('bg');

    // Here's some magic to make sure the dates are happening this month.
    // var thisMonth = moment().format('YYYY-MM');

    // Events to load into calendar
    var events2018 = [
      {
        title: 'Нова година',
        date: '2018-01-01',
        type: 'is-off'
      },
      {
        title: 'Почивен ден',
        date: '2018-03-05',
        type: 'is-off'
      },
      {
        title: 'Великден',
        start: '2018-04-06',
        end: '2018-04-09',
        type: 'is-off',
        long: true
      },
      {
        title: 'Ден на труда и на международната работническа солидарност',
        date: '2018-05-01',
        type: 'is-off'
      },
      {
        title: 'Гергьовден, Ден на храбростта и Българската армия',
        start: '2018-05-06',
        end: '2018-05-07',
        type: 'is-off',
        long: true
      },
      {
        title: 'Ден на българската просвета и култура и на славянската писменост',
        date: '2018-05-24',
        type: 'is-off'
      },
      {
        title: 'Ден на Съединението',
        date: '2018-09-06',
        type: 'is-off'
      },
      {
        title: 'Почивен ден',
        date: '2018-09-24',
        type: 'is-off'
      },
      {
        title: 'Коледа',
        start: '2018-12-24',
        end: '2018-12-26',
        type: 'is-off',
        long: true
      }
    ];

    var kndar = $('.js-kndar').clndr({
      // Start the week off on Sunday (0), Monday (1), etc. Sunday is the default.
      // WARNING: if you are dealing with i18n and multiple languages, you
      // probably don't want this! See the "Internationalization" section below
      // for more.
      // weekOffset: 1,
      daysOfTheWeek: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'нд'],

      // The target classnames that CLNDR will look for to bind events.
      // these are the defaults.
      targets: {
        day: 'c-calendar__day',
        empty: 'c-calendar__day is-empty'
      },

      // Custom classes to avoid styling issues. pass in only the classnames that
      // you wish to override. These are the defaults.
      classes: {
        past: 'has-past',
        today: 'is-today',
        event: 'has-event'
      },

      // Show the dates of days in months adjacent to the current month. Defaults
      // to true.
      showAdjacentMonths: false,

      // CLNDR can render in any time interval!
      // You can specify if you want to render one or more months, or one ore more
      // days in the calendar, as well as the paging interval whenever forward or
      // back is triggered. If both months and days are null, CLNDR will default
      // to the standard monthly view.
      lengthOfTime: {
        // Set to an integer if you want to render one or more months, otherwise
        // leave this null
        months: 12,

        // Set to an integer if you want to render one or more days, otherwise
        // leave this null. Setting this to 14 would render a 2-week calendar.
        days: null,

        // This is the amount of months or days that will move forward/back when
        // paging the calendar. With days=17 and interval=7, you would have a
        // 2-week calendar that pages forward and backward 1 week at a time.
        interval: 12
      },

      // Determines which month to start with using either a date string or a
      // moment object.
      startWithMonth: '2018-01-01',

      // If you want to prevent the user from navigating the calendar outside
      // of a certain date range (e.g. if you are making a datepicker), specify
      // either the startDate, endDate, or both in the constraints option. You
      // can change these while the calendar is on the page... See documentation
      // below for more on this!
      // constraints: {
      //     startDate: '2018-01-01',
      //     endDate: '2018-12-31'
      // },

      events: events2018,
      multiDayEvents: {
        singleDay: 'date',
        startDate: 'start',
        endDate: 'end'
      },
      template: $('#js-kndar-template').html()
    });

    $('.js-2018').on('click', function() {
      kndar.setYear(2018);
      kndar.setEvents(events2018);
    });
  });
})();
